module.exports = __webpack_public_path__ + "static/media/succeed2.423330e0.jpg";